<template lang="pug">
  el-row#placeholder-container-student(
    @mouseover.native="isHover=true"
    @mouseleave.native="isHover=false")
    
    // Question Header
    div#question-header
      el-col#question-text(:span="20") {{ getQuestionTitle }}
      el-col(v-if="questionData.score>0" :span="4") 
        div#score-text {{ questionData.score + ' ' }}
          span(v-if="questionData.score===1") pt
          span(v-else) pts
    // Question Text
    div#placeholder-content(v-html="questionData.text" style="margin-top: 20px;")

    // Question Custom Content
    component(
      :is="viewType"
      :questionData="questionData"
      :isGraded="isGraded"
      @questionSubmitted="(obj) => $emit('questionSubmitted', obj)"
    )

</template>

<script>
import AnswerInputView from '@/components/student/Question/Placeholder/AnswerInputView'
import CodingView from '@/components/student/Question/Placeholder/CodingView'
import SelectView from '@/components/student/Question/Placeholder/SelectView'

export default {
  name: 'QuestionPlaceholder',

  components: {
    AnswerInputView,
    CodingView,
    SelectView,
  },

  props: {
    id: {
      type: Number,
      required: true,
    },

    questionData: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      default: 0,
    },

    totalCount: {
      type: Number,
      default: 0,
    },

    isGraded: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    viewType() {
      const viewTypes = [
        'None',
        'AnswerInputView',
        'CodingView',
        'SelectView',
      ]
      return viewTypes[this.questionData.type_id]
    },

    getQuestionTitle: function () {
      if ( this.questionData.score > 0 && this.totalCount > 0) {
        return "Question " + this.index + " of " + this.totalCount
      }
      else {
        return this.questionData.title
      }
    },
  },
}
</script>

<style module>
  #placeholder-container-student {
    min-height: 300px;
    margin-bottom: 10px;
    border: 1px solid #f1f1f1;
    border-radius: 7px;
  }


</style>
